<template>

	<div class="main-contents">
		<div class="mem_container prj_sp">
			<!-- <div class="myp-banner">
				<img src="/images/guide_banner.png" alt="상단배너"/>
			</div>		 
			-->
			
			<div style="display: flex; width: 1200px; margin: 0 auto;">
				<div class="contents-body demand tab flex mx-0">
					<ProjectInfo :projectSeq="projectSeq" type="5" @goList="$router.go(-1)" @prjSideInfo="setPrjSideInfo" ref="updatePrjInfo"/>					
				</div>				

				<div class="sticky-btn" style="height: 260px;">
					<div class="recruit"> 
						<div class="btn_blue" @click="pageMove()">바로 지원하기</div>
						<div @click="pageMove()">							
							<img src="/images/tec/prj/heart_00.png" alt="관심등록클릭전" style="width: 20px; margin-right: 4px;"/> 
							관심 프로젝트
						</div> 
					</div>

					<div class="deadline flex-col px-0 py-0">
						<div v-if="prjSideInfo.recrEndDateDiff >= 0">
							<span class="date">
								<img src="/images/tec/prj/date_color.png" alt="마감기간"/> 
								마감 <span class="period">{{prjSideInfo.recrEndDateDiff}}</span> 일 전
								<!-- 모집마감 -->
							</span>
						</div>
						<div>
							<span>
								<img src="/images/tec/prj/member_sm.png" alt="지원자수"/>
								지원 IT프로 <span class="member">{{prjSideInfo.appCount}}</span> 명
							</span>
						</div>
					</div>

					<div class="management mt-4"> 
						<div class="profile">
							<span style="cursor: default;">
								<a>로그인 후 이용해주세요.</a>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-prj-detail" @click="$router.go(-1)">
				<span class="btn-list">
					&lt; 목록보기
				</span>
			</div>
		</div>
	</div>

</template>

<script>

import ProjectInfo from '@/components/highpro/ProjectInfo.vue';
import { projectDetailMeta } from '@/utils/meta';

export default {
	components : {
		ProjectInfo
	},

	data() {
		return {
			projectSeq : 0,
			prjSideInfo : {}
		};
	},
	beforeMount() {
		// console.log('beforeMount');
		if(this.$route.query.projectSeq != undefined && this.$route.query.projectSeq != '') {
			this.projectSeq = Number(this.$route.query.projectSeq);
		}		
	},

	props: { type : String },
	methods: {
		// 로그인 화면으로 이동
		pageMove(){
			this.$router.push({name : 'MEM001M01'});
		},

		// 프로젝트정보
		setPrjSideInfo(prjSideData){
			this.prjSideInfo = prjSideData;
		},    
	},
	metaInfo() {
		return projectDetailMeta(this.prjSideInfo.projectNm, this.prjSideInfo.projectSeq, this.prjSideInfo.projectLocCont, this.prjSideInfo.devTechCont);
	},
};
</script>
